import React, { useState } from 'react';
import {
  Button,
  DialogContent,
  CircularProgress,
  // Snackbar,
  // Alert,
} from '@mui/material';
import styles from './TrainerTermsDialog.module.scss';
import BaseDialog from '../DialogWrappers/BaseDialog';
import { locales } from '../../constants/locale';
import { useUserAction, useSessionAction } from '../../providers';

import type { Trainer } from '../../types';

const texts = locales.en.modals.trainerTerms;

export interface TrainerTermsDialogProps {
  trainer: Trainer;
  visible: boolean;
  onConsent: () => void;
  onDecline: () => void;
}

const TrainerTermsDialog: React.FC<TrainerTermsDialogProps> = ({
  trainer,
  visible,
  onConsent,
  onDecline,
}) => {
  const { updateTrainer } = useUserAction();
  const { logout } = useSessionAction();
  const [loading, setLoading] = useState<boolean>(false);
  // const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const renderTerms = () => {
    return (
      <div className={styles.terms}>
        <span className={styles.termsText}>{texts.terms}</span>
      </div>
    );
  };

  const renderConsentNote = () => {
    return (
      <div className={styles.consentNote}>
        <span className={styles.consentNote}>{texts.consentNote}</span>
      </div>
    );
  };

  const handleConsent = async () => {
    try {
      setLoading(true);
      await updateTrainer({
        ...trainer,
        preferences: {
          ...trainer.preferences,
          consentToTerms: true,
        },
      });
      onConsent();
    } catch (error) {
      console.error('Error in handleConsent:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDecline = async () => {
    logout();
    onDecline();
  };

  return (
    <>
      <BaseDialog
        isOpen={visible}
        onClose={handleDecline}
        style={{ width: 1050, margin: 'auto' }}
        title="Getting Started"
        actions={
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              className={styles.submit}
              onClick={handleConsent}
              disabled={loading}
              style={{
                borderRadius: 15,
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="primary" />
              ) : (
                <span className={styles.submitText}>{texts.consentButton}</span>
              )}
            </Button>
            <Button
              className={styles.decline}
              onClick={handleDecline}
              disabled={loading}
              style={{
                backgroundColor: 'transparent',
              }}
            >
              <span className={styles.submitText}>{texts.declineButton}</span>
            </Button>
          </div>
        }
      >
        <DialogContent className={styles.trainerTermsDialog}>
          <span className={styles.subtitle}>{texts.subtitle}</span>
          {renderTerms()}
          {renderConsentNote()}
        </DialogContent>
      </BaseDialog>
      {/* {errorMessage && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          onClose={() => setErrorMessage(null)}
        >
          <Alert onClose={() => setErrorMessage(null)} severity="error">
            {errorMessage}
          </Alert>
        </Snackbar>
      )} */}
    </>
  );
};

export default TrainerTermsDialog;
